<template>
  <CHeader fixed with-subheader light>
    <CHeaderNav class="mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/login">
          <img
            class="c-sidebar-brand-full"
            size="custom-size"
            :height="35"
            src="@/assets/fabbi_logo.jpeg"
          />
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <select
        v-model="localeSelect"
        class="form-control"
        @change="changeLanguage($event)"
      >
        <option
          v-for="(locale, key) in locales"
          :value="locale.text"
          :key="key"
          >{{ $t(`locale.${locale.text}`) }}</option
        >
      </select>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import { mapState } from "vuex";
import { loadMessages } from "../plugins/i18n";
import { loadVeeValidate } from "@/plugins/vee-validate";

export default {
  name: "HeaderGuest",
  data() {
    return {
      locales: [
        {
          text: "ja"
        },
        {
          text: "en"
        },
        {
          text: "vi"
        }
      ],
      fullPath: "",
      keyword: "",
      localeSelect: ""
    };
  },
  methods: {
    changeLanguage(event) {
      let locale = event.target.value;
      if (this.$i18n.locale !== locale) {
        this.localeSelect = locale;
        loadMessages(locale);
        loadVeeValidate(locale);
        this.$store.dispatch("lang/setLocale", { locale });
      }
    }
  },
  computed: {
    ...mapState("lang", {
      locale: state => {
        return state.locale;
      }
    })
  },
  created() {
    this.localeSelect = this.$i18n.locale;
  }
};
</script>

<style lang="scss">
.c-header-brand {
  text-decoration: none !important;
}

.logo-text {
  font-size: 20px;
}

.box-language {
  padding: 0 10px;
  margin-bottom: 0;
}
</style>
